/**
 * Starts: element bottom >= scrollPositionBottom
 * Ends: element top <= scrollPosition
 *
 * values:
 *		progress 0-1
 *		distance px
 *
 * @param {node} element
 * @param {object} dimensions - the element dimensions (height, width, top etc..)
 * @param {object} scrollPosition - the current x and y
 * @param {number} windowHeight
 * @param {number} documentHeight
 * @param {object} preferences - objects passed through, enabling reusing views
 *
 * @return {object} - with the progress (%) and distance (px)
 */
function innerView(element, dimensions, scrollPosition, windowHeight, documentHeight, preferences) {
	// The distance between start and stop
	let range = 0;

	if (dimensions.height < windowHeight) {
		range = windowHeight - dimensions.height;
	} else {
		range = dimensions.height - windowHeight;
	}

	// foldOffset makes sure, that even if an element is above the fold,
	// the progress starts at 0 - it basicly just shortens the range
	if (preferences.foldOffset) {
		if (dimensions.top + dimensions.height < windowHeight) {
			range -= windowHeight - (dimensions.top + dimensions.height);
		} else {
			range -= 0;
		}
	}

	// distance travled
	let distance = 0;

	if (dimensions.height < windowHeight) {
		distance = range - (dimensions.top - scrollPosition.y);
	} else {
		distance = scrollPosition.y - dimensions.top;
	}

	// The progress in percentage
	let progress = distance / range;

	// bottomOffset is a bit like foldOffset, it just makes
	// sure the progress reaces 1 when bottom of the page is reached
	if (preferences.bottomOffset) {
		const bottomOffset = documentHeight - (dimensions.top + dimensions.height);
		const multiplier = range / bottomOffset;

		if (bottomOffset < range) {
			progress *= multiplier;
		}
	}

	if (preferences.cap) {
		progress = Math.min(Math.max(progress, 0), 1);
	}

	// Returns an object, with distance and progress,
	// which is passed to the callback function
	return {
		progress,
		distance: range * progress,
	};
}

export default innerView;



// WEBPACK FOOTER //
// ./scripts/sky-visible/utilities/innerView.js